import React from "react";
import { Reveal } from "@/components/Reveal";
import { STEPS } from "@/data/content";

export const HowItWorks = () => {
  return (
    <section id="how-it-works" className="py-28 md:py-40 bg-charcoal text-warmwhite" data-testid="how-it-works-section">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <div className="max-w-3xl mb-16 md:mb-24">
          <Reveal>
            <p className="overline text-champagne mb-6">How It Works</p>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-light leading-[1.08]">
              Beautifully simple, from start to finish.
            </h2>
          </Reveal>
        </div>

        <div className="grid md:grid-cols-3 gap-16 md:gap-10">
          {STEPS.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.15}>
              <div className="relative" data-testid={`step-${i}`}>
                <span className="font-serif text-7xl md:text-8xl text-warmwhite/10 leading-none">{s.n}</span>
                <div className="mt-6 h-px w-full bg-warmwhite/15 mb-8">
                  <div className="h-px bg-champagne w-12" />
                </div>
                <h3 className="font-serif text-2xl md:text-3xl font-normal">{s.title}</h3>
                <p className="mt-4 text-warmwhite/60 leading-relaxed text-[15px] max-w-xs">{s.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
